import React from 'react';
import {
  arrayOf,
  params,
  shape,
  string as stringType,
  useDataModel,
} from '@thd-nucleus/data-sources';
import proptypes from 'prop-types';
import { Summary } from './subcomponents/Summary';
import { SummaryAspects } from './subcomponents/SummaryAspects';

const { func, string } = proptypes;

export const ReviewSummary = ({ itemId, selectedAspect, onAspectClick }) => {

  const { data, loading, error } = useDataModel('reviewSummary', {
    variables: {
      itemId,
      modelName: 'combined_review_summary'
    },
    ssr: false
  });

  if (loading || !data || !data?.reviewSummary) { return null; }

  if (!loading && error) { return null; }
  const {
    reviews,
    aspects
  } = data?.reviewSummary;

  return (
    <div
      data-component="magic-apron-review-summary"
      id="magic-apron-review-summary"
      className="sui-grid sui-grid-cols-1 sui-gap-x-6 sui-p-3"
    >
      <div className="sui-flex sui-flex-col sui-gap-y-1 sui-pb-3">
        <div className="sui-h6-bold sui-flex">What Customers Say</div>
        <div className="sui-text-xs sui-leading-tight sui-text-subtle">
          Summarized by generative AI from text of customer reviews
        </div>
      </div>
      <div className="sui-grid sui-grid-cols-1 sui-gap-4 lg:sui-grid-cols-2 lg:sui-gap-6">
        <Summary reviews={reviews} />
        <SummaryAspects aspects={aspects} onAspectClick={onAspectClick} selectedAspect={selectedAspect} />
      </div>
    </div>
  );
};

ReviewSummary.propTypes = {
  itemId: string.isRequired,
  selectedAspect: string,
  onAspectClick: func
};

ReviewSummary.defaultProps = {
  selectedAspect: null,
  onAspectClick: () => { }
};

ReviewSummary.dataModel = {
  reviewSummary: params({ itemId: stringType().isRequired(), modelName: stringType().isRequired() }).shape({
    reviews: shape({
      summary: stringType(),
    }),
    aspects: arrayOf(shape({
      aspect: stringType(),
      sentiment: stringType(),
    })),
    llm: stringType()
  })
};
